import { UnikoServiceTypes } from "src/app/services/payments-api.service";
import { availableServices } from "./available-services";

export const preApprovalService = {
    logo: 'assets/svgs/nbg-logo-black.svg',
    title: 'preApproval.title',
    img: '../../../../assets/img/property-service-preapprove.png',
    descPart1: `preApproval.descriptionPart1`,
    descPart2: `preApproval.descriptionPart2`,
    descPart3: `preApproval.descriptionPart3`,
    section1Title: 'whyChooseService',
    deliveryDays: 8,
    serviceFee: 100,
    whyChooseService: [
      {
        icon: 'icon-recently-view',
        title: 'preApproval.whyChoose.title1',
        description: 'preApproval.whyChoose.description1'
      },
      {
        icon: 'icon-make-an-offer',
        title: 'preApproval.whyChoose.title2',
        description: 'preApproval.whyChoose.description2'
      },
      {
        icon: 'icon-newly-build',
        title: 'preApproval.whyChoose.title3',
        description: 'preApproval.whyChoose.description3'
      }
    ],
    section2Title: 'nextSteps',
    nextSteps: [
      'preApproval.nextSteps1',
      'preApproval.nextSteps2',
      'preApproval.nextSteps3'
    ],
    section3Title: 'lookAtTheseServices.title',
    section3Description: 'lookAtTheseServices.description',
    services: availableServices.filter((service) => service.type !== UnikoServiceTypes.preapproval),
    requestServiceButtonLabel: 'preApproval.requestPreApproval',
  }